import React from "react";
import Link from "../Link";
import group5 from "../../img/group-6-black.svg";
import right2 from "../../img/right@2x.svg";
import "./IncomeBreakdownButton.css";

const IncomeBreakdownButton = (props) => {
    const { className, handLogo } = props;

    return (
        <Link href="/revenue">
            <div className="income-breakdown-button">
                <img className="vector-65-99" src={`${handLogo || group5}`} />
                <div className={`income-breakdown ${className || "nunito-bold-black-14px"}`}>Income Breakdown</div>
                <img className="right-7" src={right2} />
            </div>
        </Link>
    );
};
export default IncomeBreakdownButton;